import { dataChat } from 'dls-icons-data'
import { createIcon } from '../common'

const IconChat = /*#__PURE__*/createIcon(dataChat)
export default IconChat
